const STORAGE_ORDER_LIST = "34xzOr?Ls,.x-0";
const STORAGE_ORDER_CREATOR = "35xzOr?Cr,.x-1";
const STORAGE_ORDER_ID = "36xyOr?Oi,.x-2";
const STORAGE_SHOPPING_CART = "37wzOr?Sc,.x-3";

export {
  STORAGE_ORDER_LIST,
  STORAGE_ORDER_CREATOR,
  STORAGE_ORDER_ID,
  STORAGE_SHOPPING_CART,
};
